import React, { useState } from 'react'
import styles from './A23GameActionButton.module.css'
import { ALL_IN_ACTION, CALL_ACTION, CHECK_ACTION, FOLD_ACTION, RAISE_ACTION, RUPEE_SYMBOL } from '@/Poker/data/Constants'
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import RaiseBar from '../../RaiseBar/RaiseBar';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { parseDecimalValuesOfNumber } from '../../../../Common/utils/GameUtils';

export default function A23GameActionButton({ tempTableId, action, callAmount, allInForCall }) {
    const {
        sendCallProtocol,
        sendCheckProtocol,
        sendRaiseProtocol,
        sendFoldProtocol,
        sendAllInProtocol
    } = useGameSocket(tempTableId);
    const [raiseAmount, setRaiseAmount] = useState(0);

    const handleGameActionButton = () => {
        if (action === CALL_ACTION) {
            sendCallProtocol();
        }
        if (action === CHECK_ACTION) {
            sendCheckProtocol();
        }
        if (action === RAISE_ACTION) {
            if (raiseAmount) {
                sendRaiseProtocol(raiseAmount);
            }
        }
        if (action === FOLD_ACTION) {
            sendFoldProtocol();
        }
        if (action === ALL_IN_ACTION) {
            if (allInForCall) {
                sendCallProtocol();
            } else {
                sendAllInProtocol();
            }
        }
    }

    const handleRaisePopoverVisibilityChange = (status) => {
        if (!status) {
            setRaiseAmount(0);
        }
    }

    if (action === RAISE_ACTION) {
        return (
            <Popover onOpenChange={handleRaisePopoverVisibilityChange}>
                <PopoverTrigger onClick={handleGameActionButton} asChild>
                    <div className={`${styles.gameActionButton} ${action === ALL_IN_ACTION ? styles.allIn : styles[action]}`}>
                        <div className={styles.gameActionButtonLabel}>{action}{raiseAmount ? ` ${RUPEE_SYMBOL + parseDecimalValuesOfNumber(raiseAmount, 2)}` : ''}</div>
                    </div>
                </PopoverTrigger>
                <PopoverContent className={styles.raisePopoverContent}>
                    <RaiseBar raiseAmount={raiseAmount} setRaiseAmount={setRaiseAmount} tempTableId={tempTableId} />
                </PopoverContent>
            </Popover>
        )
    }

    return (
        <>
            <div onClick={handleGameActionButton} className={`${styles.gameActionButton} ${action === ALL_IN_ACTION ? styles.allIn : styles[action]}`}>
                <div className={styles.gameActionButtonLabel}>{action}{callAmount ? ` ${RUPEE_SYMBOL + callAmount}` : ''}</div>
            </div>
        </>
    )
} 